import { ReactElement } from 'react'
import { TableBody } from '@mui/material'
import DevelopusTableRow, {
  DevelopusTreeTableItemType,
} from './DevelopusTreeTableRow'
import { UUID } from 'crypto'

export type DevelopusTreeTableBodyType = {
  items: DevelopusTreeTableItemType[]
}

interface Props {
  body: DevelopusTreeTableBodyType
  page: number
  rowsPerPage: number
  handleEdit: (id?: UUID) => void
  handleRemove: (id?: UUID) => void
}

const DevelopusTreeTableBody = (props: Props): ReactElement => {
  const from = props.page * props.rowsPerPage
  const to = from + props.rowsPerPage

  const items = props.body.items.slice(from, to)

  return (
    <TableBody>
      {items.map((item, idx) => (
        <DevelopusTableRow
          key={idx}
          item={item}
          handleEdit={props.handleEdit}
          handleRemove={props.handleRemove}
        />
      ))}
    </TableBody>
  )
}

export default DevelopusTreeTableBody
